import React, { useCallback, useEffect, useState } from 'react';

import { GET_ONE, provider, history } from '../_utils';
import { GeneralInfo, OperatorContracts } from './components/Show';
import EditOperatorModal from './components/Show/EditOperatorModal';
import {
    TYPE_META,
    deptLabel,
    fmtDate,
    fmtPhone,
    fmtStamp,
    formatAddress,
    fullName,
    initials,
    mobilePhone,
    otherPhone,
    placeLabel,
    statusMeta,
    telegram,
    telegramHref,
    telegramLinked,
    typeLabel,
} from './format';
import './operators.css';

const showClasses = {
    sectionTitle: '',
    scheduleSection: '',
    generalInfoCard: '',
    paySheetTable: '',
    paySheetTableHeader: '',
    paySheetTableCell: '',
    statusField: '',
    statusFieldLabel: '',
    statusFieldSucces: '',
    statusFieldError: '',
};

const Val = ({ value, mono, href }) => {
    if (!value) return <span className="v empty">не заполнено</span>;
    if (href) return <span className={`v${mono ? ' m' : ''}`}><a href={href}>{value}</a></span>;
    return <span className={`v${mono ? ' m' : ''}`}>{value}</span>;
};

const OperatorShow = ({ match }) => {
    const [data, setData] = useState(null);
    const [tab, setTab] = useState('docs');
    const [showPersonal, setShowPersonal] = useState(false);
    const [editOpen, setEditOpen] = useState(false);

    const id = match.params.id;

    const load = useCallback(async () => {
        const { data: item, status } = await provider(GET_ONE, '/operators', id);
        if (status >= 200 && status < 300) setData(item);
    }, [id]);

    useEffect(() => { load(); }, [load]);
    const meta = TYPE_META[data?.type] || TYPE_META.staf;
    const status = statusMeta(data);
    const phone = mobilePhone(data);
    const phone2 = otherPhone(data);
    const tg = telegram(data);
    const linked = telegramLinked(data);
    const address = formatAddress(data?.contact?.address);
    const passport = data?.passport || {};
    const filledPersonal = [passport.birthday, passport.personal_number, passport.number].filter(Boolean).length;

    const name = fullName(data);

    if (!data) {
        return (
            <div className="pc-page pc-emp">
                <div className="pc-emp-topbar">
                    <button type="button" className="pc-emp-btn" onClick={() => history.push('/operators')}>
                        Все сотрудники
                    </button>
                </div>
            </div>
        );
    }

    return (
        <div className="pc-page pc-emp">
            <div className="pc-emp-topbar">
                <button type="button" className="pc-emp-btn" onClick={() => history.push('/operators')}>
                    <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.7">
                        <path d="M13 8H4M7.5 4.5L4 8l3.5 3.5" />
                    </svg>
                    Все сотрудники
                </button>
                <div className="pc-emp-end">
                    <button type="button" className="pc-emp-btn" onClick={() => history.push('/operators/reports')}>
                        Отчеты
                    </button>
                    <button
                        type="button"
                        className="pc-emp-btn"
                        disabled={!linked}
                        onClick={() => { const href = telegramHref(data); if (href) window.open(href, '_blank'); }}
                    >
                        Написать
                    </button>
                    <button type="button" className="pc-emp-btn" onClick={() => setEditOpen(true)}>
                        Редактировать
                    </button>
                </div>
            </div>

            <div className="pc-emp-stage">
                <div className="pc-emp-panel">
                    <div className="pc-emp-chd">
                        <div className={`pc-emp-ava av-${meta.av}`}>{initials(name)}</div>
                        <div className="pc-emp-who">
                            <h2>{name || 'Сотрудник'}</h2>
                            <div className="sub">{data.login || '—'}</div>
                        </div>
                    </div>

                    <div className="pc-emp-cols">
                        <div className="pc-emp-left">
                            <div className="pc-emp-sect">
                                <div className="pc-emp-sect__t">Основное</div>
                                <div className="pc-emp-dl">
                                    <div className="r"><span className="k">Тип</span><span className="v">{typeLabel(data.type)}</span></div>
                                    <div className="r"><span className="k">Логин</span><span className="v m">{data.login || '—'}</span></div>
                                    <div className="r">
                                        <span className="k">Статус</span>
                                        <span className="v">
                                            <span className={`pc-emp-chip ${status.chip}`}>
                                                <span className="pc-emp-dot" />
                                                {status.label}
                                            </span>
                                        </span>
                                    </div>
                                    <div className="r"><span className="k">Подразделение</span><Val value={deptLabel(data.department)} /></div>
                                    <div className="r"><span className="k">Офис</span><Val value={placeLabel(data.place)} /></div>
                                    <div className="r"><span className="k">В компании с</span><Val value={fmtDate(data.createdAt)} mono /></div>
                                </div>
                            </div>

                            <div className="pc-emp-sect">
                                <div className="pc-emp-sect__t">Связь</div>
                                <div className="pc-emp-dl">
                                    <div className="r">
                                        <span className="k">Мобильный</span>
                                        <Val value={phone ? fmtPhone(phone) : ''} mono href={phone ? `tel:+${String(phone).replace(/\D/g, '')}` : undefined} />
                                    </div>
                                    <div className="r"><span className="k">Другой</span><Val value={phone2 ? fmtPhone(phone2) : ''} mono /></div>
                                    <div className="r"><span className="k">Telegram</span><Val value={linked ? tg : ''} /></div>
                                    <div className="r">
                                        <span className="k">Mini App</span>
                                        <span className="v">
                                            {data.telegramId || data.contact?.telegramId
                                                ? <span className="pc-emp-chip pc-emp-chip--ok">привязан</span>
                                                : <span className="empty">не привязан</span>}
                                        </span>
                                    </div>
                                    <div className="r">
                                        <span className="k">E-mail</span>
                                        <Val value={data.contact?.email} href={data.contact?.email ? `mailto:${data.contact.email}` : undefined} />
                                    </div>
                                    <div className="r"><span className="k">Адрес</span><Val value={address} /></div>
                                </div>
                                {!linked && (
                                    <div className="pc-emp-note">
                                        Telegram не привязан — уведомления о сменах не приходят.
                                    </div>
                                )}
                            </div>

                            <div className="pc-emp-sect">
                                <div className="pc-emp-sect__t">
                                    Личные данные
                                    <button type="button" onClick={() => setShowPersonal((v) => !v)}>
                                        {showPersonal ? 'Скрыть' : 'Показать'}
                                    </button>
                                </div>
                                {showPersonal ? (
                                    <>
                                        <div className="pc-emp-dl">
                                            <div className="r"><span className="k">Дата рождения</span><Val value={fmtDate(passport.birthday)} mono /></div>
                                            <div className="r"><span className="k">Личный номер</span><Val value={passport.personal_number} mono /></div>
                                            <div className="r"><span className="k">Паспорт</span><Val value={passport.number} mono /></div>
                                            <div className="r"><span className="k">Дата выдачи</span><Val value={fmtDate(passport.date_issue)} mono /></div>
                                            <div className="r"><span className="k">Орган выдачи</span><Val value={passport.issue} /></div>
                                        </div>
                                        <div className="pc-emp-lock" style={{ marginTop: 9 }}>
                                            <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5">
                                                <rect x="3" y="7" width="10" height="7" rx="1.4" />
                                                <path d="M5.5 7V5a2.5 2.5 0 015 0v2" />
                                            </svg>
                                            <span>Паспортные данные скрыты по умолчанию.</span>
                                        </div>
                                    </>
                                ) : (
                                    <div className="pc-emp-lock">
                                        <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5">
                                            <rect x="3" y="7" width="10" height="7" rx="1.4" />
                                            <path d="M5.5 7V5a2.5 2.5 0 015 0v2" />
                                        </svg>
                                        <span>Паспортные данные скрыты. Заполнено {filledPersonal} из 3 полей.</span>
                                    </div>
                                )}
                            </div>
                        </div>

                        <div className="pc-emp-right">
                            <div className="pc-emp-tabs">
                                <button type="button" className={tab === 'docs' ? 'on' : ''} onClick={() => setTab('docs')}>Документы</button>
                                <button type="button" className={tab === 'common' ? 'on' : ''} onClick={() => setTab('common')}>Общее</button>
                            </div>
                            <div className="pc-emp-pane">
                                {tab === 'docs' && (
                                    <div className="pc-emp-card">
                                        <div className="ch"><h3>Договоры</h3></div>
                                        <div className="cb">
                                            <OperatorContracts data={data} classes={showClasses} onDataUpdate={load} />
                                        </div>
                                    </div>
                                )}
                                {tab === 'common' && (
                                    <div className="pc-emp-card">
                                        <div className="ch"><h3>Расчётные листы</h3></div>
                                        <div className="cb">
                                            <GeneralInfo data={data} paySheetsData={data.reports || data.paySheets || []} classes={showClasses} />
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>

                    <div className="pc-emp-cft">
                        <span className="pc-emp-chip pc-emp-chip--mono">
                            {data.updateAt ? `обновлено ${fmtStamp(data.updateAt)}` : '—'}
                        </span>
                    </div>
                </div>
            </div>

            <EditOperatorModal
                open={editOpen}
                onClose={() => setEditOpen(false)}
                operatorData={data}
                onSave={load}
            />
        </div>
    );
};

export default OperatorShow;
